import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextRotationDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_rotation_down"}/>
}
